import eventBus from '../../eventBus';
import { configuredLanguage } from '../../i18n';
import { normalizeLocaleString } from '../../i18n/localeUtils';
let formatLocale = configuredLanguage;

// Normally would use the global consts for event name and settings key but those
// are in nova-commons. Have to hard-code them in nova-core instead.
eventBus.subscribe('SettingsEvent.Change', (_eventName, eventData) => {
  if (!eventData || !eventData.data || !eventData.data.data) return;
  for (const entry of eventData?.data?.data) {
    if (entry.key === 'FormatLocale.DefaultLocale') {
      formatLocale = entry.value ?? 'en';
    }
  }
});
export const setAcceptLocaleHeader = locale => {
  formatLocale = locale;
};
export const addAcceptLocaleHeader = config => {
  config.headers = config.headers ?? {};
  config.headers['Accept-Locale'] = config.headers['Accept-Locale'] ?? normalizeLocaleString(formatLocale);
  return config;
};
//# sourceMappingURL=accept-locale-header.js.map